// Shared backdrop and emblem for the signed-out and signed-in landing pages.

import type { ReactNode } from "react";

/** Night-sky photo behind a centred column, matching the town square's own backdrop. */
export function PageShell({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  return (
    <div
      className="grid min-h-full place-items-center bg-cover bg-center px-6 py-10"
      style={{
        backgroundImage: 'linear-gradient(rgba(4,4,10,0.6), rgba(4,4,10,0.82)), url("/photos/night1.jpg")',
      }}
    >
      <div className={`cc-fade-in w-full ${wide ? "max-w-lg" : "max-w-md"}`}>{children}</div>
    </div>
  );
}

/** A brass clock face whose minute hand sweeps slowly, echoing the vote hand in the circle. */
export function ClockEmblem({ className = "h-16 w-16" }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={`mx-auto text-brass ${className}`} fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" />
      <circle cx="32" cy="32" r="24" stroke="currentColor" strokeOpacity="0.35" strokeWidth="1" />
      {Array.from({ length: 12 }, (_, i) => (
        <line
          key={i}
          x1="32"
          y1="9"
          x2="32"
          y2={i % 3 === 0 ? 14 : 12}
          stroke="currentColor"
          strokeWidth={i % 3 === 0 ? 2 : 1}
          transform={`rotate(${i * 30} 32 32)`}
        />
      ))}
      <line x1="32" y1="32" x2="32" y2="21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <g style={{ transformOrigin: "32px 32px", animation: "cc-sweep 60s linear infinite" }}>
        <line x1="32" y1="32" x2="32" y2="13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </g>
      <circle cx="32" cy="32" r="2.5" fill="currentColor" />
    </svg>
  );
}

